module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20216.f4de8f2f.jpg";